import { post, remove } from '../../../redux/api';

const getTokensEndpoint = (projectGroupId: number) => `/api/project_group/${projectGroupId}/portal-tokens`;

/**
 * Add and remove tokens from a project group.
 */
export async function commitTokenChanges(
  projectGroupId: number,
  addTokenIds: number[],
  removeTokenIds: number[],
): Promise<void> {
  const tokensEndpoint = getTokensEndpoint(projectGroupId);
  if (addTokenIds.length > 0) {
    await post(tokensEndpoint, { ids: addTokenIds });
  }
  if (removeTokenIds.length > 0) {
    await remove(tokensEndpoint, {
      body: { ids: removeTokenIds },
      json: true,
    });
  }
}
